import React from 'react';
import { Modal } from 'antd';
import { InfoCircleOutlined  } from "@ant-design/icons";

const SessionExpiredModal = ({ open, visible, onOk }) => {
  return (
    <Modal
      title="Session Expired"
      open={open ?? visible}
      onOk={onOk}
      onCancel={onOk} // Close the modal and redirect on cancel as well
      closable={false} // Prevent closing the modal by clicking outside or the close button
      okText="Log In"
      cancelButtonProps={{ style: { display: 'none' } }} // Hide the cancel button
    >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <InfoCircleOutlined style={{ fontSize: "24px", color: "blue" }} />
            <span>Your session has expired. Please log in again.</span>
       </div>
    </Modal>
  );
};

export default SessionExpiredModal;